module.exports = __webpack_public_path__ + "static/media/SP_C_Embroidery_Bicocca_DKGrey_White.767248ee.png";